"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrbitalConstructionYard = void 0;
var Tags_1 = require("../Tags");
var PreludeCard_1 = require("./PreludeCard");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var OrbitalConstructionYard = (function (_super) {
    __extends(OrbitalConstructionYard, _super);
    function OrbitalConstructionYard() {
        return _super.call(this, {
            name: CardName_1.CardName.ORBITAL_CONSTRUCTION_YARD,
            tags: [Tags_1.Tags.SPACE],
            metadata: {
                cardNumber: 'P25',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.titanium(1); }).br;
                    b.titanium(4);
                }),
                description: 'Increase your titanium production 1 step. Gain 4 titanium.',
            },
        }) || this;
    }
    OrbitalConstructionYard.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.TITANIUM, 1);
        player.titanium += 4;
        return undefined;
    };
    return OrbitalConstructionYard;
}(PreludeCard_1.PreludeCard));
exports.OrbitalConstructionYard = OrbitalConstructionYard;
